import LogUsers from '../components/ListUsers/LogUsers'

const LogPage = () => (
    <LogUsers />
)

export default LogPage